<div class="p-lg border-stroke-neutral-light flex justify-between border-b bg-white">
  <div class="gap-xs flex flex-col">
    <h1 class="title-small-semibold">Offre régionale</h1>
    <brn-select
      class="inline-block"
      (valueChange)="setCartographieCourante($event)"
      placeholder="Sélectionnez une cartographie"
    >
      <hlm-select-trigger class="w-max">
        {{ cartographie().nom }}
      </hlm-select-trigger>
      <hlm-select-content>
        @for (cartographie of cartographies() | trierPar: 'nom'; track cartographie.id) {
          <hlm-option [value]="cartographie">{{ cartographie.nom }}</hlm-option>
        }
      </hlm-select-content>
    </brn-select>
  </div>

  <div class="gap-sm flex items-center">
    @if (cartographie().estVerrouilleeOffreRegionale) {
      <app-chip label="Verrouillée" variant="warning"></app-chip>
    }

    @if (isAdmin()) {
      <button (click)="toggleVerouillageOffreRegionale()" hlmBtn variant="secondary">
        @if (!cartographie().estVerrouilleeOffreRegionale) {
          <ng-icon name="lucideLockKeyhole" hlm size="sm" />
          Verrouiller l'offre régionale
        } @else {
          <ng-icon name="lucideLockKeyholeOpen" hlm size="sm" />
          Déverrouiller l'offre régionale
        }
      </button>
    } @else {
      <button (click)="selectionnerSite()" hlmBtn variant="secondary">
        <ng-icon name="lucidePlus" />
        Ajouter des formations
      </button>
    }
    <button [appBadge]="nbFiltres()" (click)="onFilter.emit()" size="xxl" hlmBtn variant="secondary">
      <ng-icon hlm name="lucideListFilter" size="sm" />
    </button>
  </div>
</div>
